import { DEFAULT_CURRENCY } from '@procureai/schemas';
import { CurrencyProvider } from '@procureai/ui-mui';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { ModuleEntityType } from '~/common/types';
import { DateRangeProvider } from '~/components/DateRangeProvider';
import { ModuleContextProvider, ModuleContextProviderValue } from '~/components/ModuleContextProvider';
import { ModulePage } from '~/components/ModulePage/ModulePage';
import { useModulePageConfig } from '~/components/ModulePageConfigProvider';
import { ModuleSlot } from '~/components/ModuleSlot/ModuleSlot';
import { ResponsibleUsersProvider } from '~/components/ResponsibleUsersProvider';
import { ModuleSlotId, useTabId } from '~/modules';
// TODO: Implement hooks for sourcing project context
// import { useSourcingProjectDetail, useTabId } from '~/modules/Module.hooks';
import { RouteId } from '~/routes';

import { SourcingProjectDetailHeader } from './SourcingProjectDetailHeader/SourcingProjectDetailHeader';

export const SourcingProjectDetail = () => {
  const { sourcingProjectId } = useParams() as { sourcingProjectId: string };
  const { tabId } = useTabId();

  const { modules, tabs } = useModulePageConfig({ pageId: RouteId.sourcingProjectDetail(), tabId });

  const contextValue = useMemo<ModuleContextProviderValue>(
    () => ({ entity: ModuleEntityType.SOURCING_PROJECT, entityId: sourcingProjectId }),
    [sourcingProjectId],
  );

  return (
    <CurrencyProvider value={DEFAULT_CURRENCY}>
      <DateRangeProvider>
        <ResponsibleUsersProvider>
          <ModulePage
            header={<SourcingProjectDetailHeader id={sourcingProjectId} tabs={tabs} />}
            modules={
              <ModuleContextProvider value={contextValue}>
                <ModuleSlot id={ModuleSlotId.MAIN} modules={modules} />
              </ModuleContextProvider>
            }
          ></ModulePage>
        </ResponsibleUsersProvider>
      </DateRangeProvider>
    </CurrencyProvider>
  );
};
